import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getMainAppList } from '@api/api';
import * as appListAction from '@store/actions/appListAction';
import { getToday, addDates } from '@common/utils/date';
import { useHistory } from 'react-router-dom';

const HOME_APP_LISTS = [
  {
    key: 'applyCnt',
    name: '청약',
    className: 'red',
  },
  {
    key: 'splemntCnt',
    name: '보완',
    className: 'brown',
  },
  {
    key: 'uwDoneCnt',
    name: '심사완료',
    className: 'yellow',
  },
  {
    key: 'happyCallCnt',
    name: '해피콜',
    className: 'gray',
  },
  {
    key: 'returnCnt',
    name: '반송',
    className: 'gray',
  },
];

const HomeMainAppList = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [appListInfo, setAppListInfo] = useState({});

  const moveToAppList = () => {
    dispatch(
      appListAction.saveSearchParms({
        searchStartDate: addDates(getToday(), 'months', -1, 'yyyyMMdd'),
        searchEndDate: getToday('yyyyMMdd'),
        searchState: 'ALL',
        pageIndex: '1',
        custNo: '',
        searchName: '',
        pageConditionKey: '',
        pageCount: 10,
        pageNextYn: '',
      }),
    );

    history.push('/appList');
  };

  useEffect(() => {
    let isMounted = true;

    const checkMainAppList = async () => {
      const { data } = await getMainAppList({});
      const appList = data?.data;

      if (isMounted) setAppListInfo(appList);
    };

    // 로컬 테스트시 느려서 막음
    if (!$utils.isLocal) {
      checkMainAppList();
    }

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div className="half app-box-main">
      <div className="ico-group-2 ico-new-paper">
        <h3 className="tit3">청약 진행 현황</h3>
      </div>

      <div className="curent-wrap ">
        {HOME_APP_LISTS.map(({ key, name, className }, index) => (
          <ul key={key} className="curent-content" onClick={moveToAppList}>
            <li className={$classNames('ico-curent-box', `step-${index + 1}`)}>
              <div className={$classNames('alert-num', className)}>
                {appListInfo?.[key]}
              </div>
            </li>
            <li className="ico-curent-text">{name}</li>
          </ul>
        ))}
      </div>
    </div>
  );
};

export default HomeMainAppList;
